import qs from 'qs';

const getParsedQs = (queryString: string) => qs.parse(queryString && queryString.slice(1));

export const getQueryStringValues = (queryString: string = window.location.search) => getParsedQs(queryString);
